<template lang="pug">
.progress-bar-container
  .progress-bar-header
    .title {{ skill }}
    .level(v-if="showLevel") {{ normalizedLevel }}
  .progress-bar
    div(
      v-for="(step, index) in 5"
      :key="index"
      :class="['step', { active: index < activeSteps }]"
    )
</template>

<script>
export default {
  name: 'BarraHabilidades',
  props: {
    skill: {
      type: String,
      required: true,
    },
    level: {
      type: String,
      required: true
    },
    showLevel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      levelMap: {
        Iniciando: 0,
        Aprendiz: 1,
        Praticante: 2,
        Profissional: 3,
        Professor: 4,
        Mestre: 5,
      }
    }
  },
  computed: {
    normalizedLevel() {
      if (!this.level) return ''
      return this.level.charAt(0).toUpperCase() + this.level.slice(1).toLowerCase()
    },
    activeSteps() {
      return this.levelMap[this.normalizedLevel] || 0
    }
  }
}
</script>

<style scoped lang="scss">
.progress-bar-container {
  width: 100%;
  max-width: 1360px;

  .progress-bar-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;

    .title {
      font-size: 14px;
      color: $corBranco;
    }

    .level {
      font-size: 12px;
      color: $corValueInfoContato;
    }
  }

  .progress-bar {
    display: flex;
    height: 12px;
    border-radius: 999px;
    overflow: hidden;
    background-color: $corPreto;

    .step {
      flex: 1;
      background-color: $borderColor;
      border-right: 2px solid $corPreto;

      &:last-child {
        border-right: none;
      }

      &.active {
        background-color: $corVerdeClaro;
      }
    }
  }
}

// Adiciona espaçamento entre múltiplos .progress-bar-container
.progress-bar-container + .progress-bar-container {
  margin-top: 12px;
}
</style>
